export default __webpack_public_path__ + "static/default-thumb-fdb85fcb043f54b4387ac41b22a17f26.png";